import { render, staticRenderFns } from "./CandidateList.vue?vue&type=template&id=9e93cda2&scoped=true"
import script from "./CandidateList.vue?vue&type=script&lang=js"
export * from "./CandidateList.vue?vue&type=script&lang=js"
import style0 from "./CandidateList.vue?vue&type=style&index=0&id=9e93cda2&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9e93cda2",
  null
  
)

export default component.exports